export default __webpack_public_path__ + "static/media/property_584.b00f80aa.png";